import { render, staticRenderFns } from "./CardModalLayout.vue?vue&type=template&id=31496075"
import script from "./CardModalLayout.vue?vue&type=script&lang=ts"
export * from "./CardModalLayout.vue?vue&type=script&lang=ts"
import style0 from "./CardModalLayout.vue?vue&type=style&index=0&id=31496075&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports